import { render } from "./ConfirmEmailPage.vue?vue&type=template&id=72a8efa1"
import script from "./ConfirmEmailPage.vue?vue&type=script&lang=js"
export * from "./ConfirmEmailPage.vue?vue&type=script&lang=js"

import exportComponent from "/src/Ewallet.Web/Scripts/landing-page/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__